/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { Banner } from '@cox/core-ui8/dist/Banner'
import { useSearchContext } from '@cox/core-ui8/dist/SearchContext'

import { INVERSION_PAGE_TYPES } from '../../constants'
import { useInversionData } from '../../hooks/useInversionData'
import { DynamicMediaComponents, getDynamicMedia } from '../../utils/dynamic-media-util'
import { getTokenValues } from '../../utils/rule-builder-util'
import { getSpacing } from '../../utils/spacing-util'
import { ReactBannerProps } from '../ReactBanner'
import IsInEditorText from '../shared/IsInEditorText'

const ReactBanner = (props: ReactBannerProps): JSX.Element => {
  const {
    bannerType,
    isInEditor = false,
    bannerId = '',
    top = false,
    right = false,
    bottom = false,
    left = false,
    lob = '',
    iconPath = '',
    altIcon = '',
    message = '',
    buttonStates,
    linkText,
    openInNewTab,
    link,
    linkUrl,
    linkId,
    linkType,
    fileName,
    tokenProperties,
    variations,
    text,
    simplified,
    icon,
    anchor,
    chatText,
    isDismissable = false
  } = props

  // Show banner if there is no search results or API error
  const { hasNoLinksSearchResults, hasNoGenSearchResults, hasNoSearchQuery, isSearch } = useSearchContext()
  let displayBanner = hasNoSearchQuery || hasNoLinksSearchResults

  if (hasNoLinksSearchResults && !hasNoGenSearchResults) {
    displayBanner = false
  }

  const imgSrc = (iconPath && getDynamicMedia(iconPath, DynamicMediaComponents.BANNER, fileName)) || iconPath
  const altIconText = (getTokenValues(altIcon, tokenProperties) as string) || ''
  const linkMsg = text || linkText
  const inversionItems = useInversionData()
  const { appData } = useAppDataContext()
  const { pageType = '', isLocal = false } = appData?.page ?? {}
  const firstItem = inversionItems?.[0] ?? {}
  const { property_name_display = '', directions_link = '' } = firstItem
  const isLocalLogic = isLocal === 'true' && pageType.includes(INVERSION_PAGE_TYPES.communities_address)

  const messageToBeDisplayed = isLocalLogic ? property_name_display : message
  const bannerLink = isLocalLogic ? (directions_link ?? '#') : link || linkUrl

  if (isSearch && !displayBanner) {
    return <>{IsInEditorText(isInEditor, 'React Banner')}</>
  }

  return (
    <div
      data-testid={`react-banner-container`}
      className={`react-banner-container ${getSpacing(top, right, bottom, left)} ${lob}`}
      id={bannerId}
    >
      {IsInEditorText(isInEditor, 'React Banner')}
      <Banner
        bannerType={bannerType}
        message={messageToBeDisplayed}
        buttonStates={buttonStates}
        linkText={linkMsg}
        openInNewTab={openInNewTab}
        linkUrl={bannerLink}
        linkId={linkId}
        //@ts-ignore
        linkType={linkType}
        iconPath={imgSrc}
        altIcon={altIconText}
        variation={variations}
        simplified={simplified}
        buttonIcon={icon}
        anchor={anchor}
        chatText={chatText}
        isDismissable={isDismissable}
        tokenProperties={tokenProperties}
      />
    </div>
  )
}
export default ReactBanner
